import { useState } from "react";
import { motion } from "framer-motion";
import { MaskLines, Overline, FadeUp } from "@/components/motion";
import { useLang } from "@/context/LangContext";
import { useImg } from "@/lib/design";

const Side = ({ id, title, text, lit, onHover, img, imgKey }) => (
  <motion.div
    data-testid={`choice-${id}`}
    onMouseEnter={onHover}
    onFocus={onHover}
    tabIndex={0}
    animate={{ flexGrow: lit ? 1.5 : 1 }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
    className="relative flex min-h-[320px] basis-0 cursor-default flex-col justify-end overflow-hidden rounded-[28px] border border-[#F4EEE2]/10 p-7 outline-none md:min-h-[520px] md:p-10"
  >
    <img src={img} data-ve-img={imgKey} alt="" className={`absolute inset-0 h-full w-full object-cover transition-[filter,transform] duration-[1.2s] ${lit ? "scale-105 grayscale-0" : "grayscale"}`} />
    <div className={`absolute inset-0 transition-colors duration-700 ${lit ? "bg-[#0B111E]/45" : "bg-[#0B111E]/80"}`} />
    {id === "jesus" && <div className={`absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(212,175,55,0.35),transparent_60%)] transition-opacity duration-700 ${lit ? "opacity-100" : "opacity-0"}`} />}
    <div className="relative">
      <h3 className={`font-display text-5xl font-semibold transition-colors duration-500 md:text-7xl ${lit && id === "jesus" ? "text-[#F3D27A]" : "text-[#F4EEE2]"}`}>{title}</h3>
      <p className="mt-4 max-w-sm text-base leading-relaxed text-[#E3E7EE]">{text}</p>
    </div>
  </motion.div>
);

export const Choice = () => {
  const { t } = useLang();
  const worldImg = useImg("choice_world");
  const jesusImg = useImg("choice_jesus");
  const [lit, setLit] = useState("jesus");
  return (
    <section data-testid="choice-section" className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-36">
      <div className="mb-14 grid gap-6 md:grid-cols-12">
        <div className="md:col-span-7">
          <Overline>{t("choice.over")}</Overline>
          <MaskLines lines={[t("choice.title")]} className="font-display mt-5 text-5xl font-semibold leading-[1] text-[#F4EEE2] md:text-7xl" />
        </div>
        <FadeUp className="self-end md:col-span-5">
          <p className="font-display text-xl italic text-[#D4AF37] md:text-2xl">{t("choice.verse")}</p>
        </FadeUp>
      </div>
      <FadeUp className="flex flex-col gap-4 md:flex-row">
        <Side id="world" title={t("choice.world")} text={t("choice.worldText")} lit={lit === "world"} onHover={() => setLit("world")} img={worldImg} imgKey="choice_world" />
        <Side id="jesus" title={t("choice.jesus")} text={t("choice.jesusText")} lit={lit === "jesus"} onHover={() => setLit("jesus")} img={jesusImg} imgKey="choice_jesus" />
      </FadeUp>
    </section>
  );
};
